import { ActivityFeedEntityLinkDto } from 'api/activity-feed';
import { BranchCode } from 'api/risk';
import { getEntityLabel, parseMessage } from 'features/activity-feed/utils/messageParser';

/** Jeton d'entité brut ({Type:Guid}) laissé tel quel quand l'entité est inconnue. */
const RAW_ENTITY_TOKEN = /\{[^:}]+:[^}]+\}/;

/** Libellés des branches portées par un lead partenaire (repli : le code brut). */
const BRANCH_LABELS: Record<string, string> = {
  [BranchCode.UPI]: 'Bailleur non occupant',
  [BranchCode.RGI]: 'Loyers impayés',
  [BranchCode.Borrower]: 'Assurance emprunteur',
  [BranchCode.Mri]: 'Multirisque immeuble',
  [BranchCode.Unemployment]: 'Perte d’emploi',
  [BranchCode.Pet]: 'Animaux'
};

export const branchLabel = (branchCode?: string | null): string | null => {
  if (!branchCode) return null;
  return BRANCH_LABELS[branchCode.toUpperCase()] ?? branchCode;
};

/**
 * Message d'une notification rendu en texte lisible : les jetons `{Type:Guid}`
 * sont remplacés par le libellé de l'entité. Une clause dont le jeton n'a pas
 * d'entité connue est JETÉE en entier — mieux vaut « … transmis par Meleine » que
 * « … transmis par Meleine — dossier {RisqueAssure:3a23…} ». Le n° de dossier a de
 * toute façon sa place propre dans la carte.
 */
export const readableMessage = (
  message: string,
  entities: ActivityFeedEntityLinkDto[]
): string =>
  parseMessage(message, entities)
    .map((part) =>
      part.type === 'entity' && part.entityType && part.entityId
        ? getEntityLabel(entities, part.entityType, part.entityId)
        : part.content
    )
    .join('')
    .split(/\s+[—–]\s+/)
    .filter((clause) => !RAW_ENTITY_TOKEN.test(clause))
    .join(' — ')
    .trim();
